module.exports = __webpack_public_path__ + "img/sld_scb_5_t1_b1_dark.bf600409.svg";